import "./styles.scss";

const KvTable = ({ rows = [] }) => (
  <div className="referenceSheet__kvTable">
    {rows.map((row, index) => (
      <div key={`${row.key}-${index}`} className="referenceSheet__kvRow">
        <strong>{row.key}</strong>
        <span>{row.value}</span>
      </div>
    ))}
  </div>
);

const HighlightBlock = ({ heading, content }) => (
  <div className="referenceSheet__highlight">
    <span className="referenceSheet__highlightTitle">{heading}:</span>
    <p>
      {content.split("\n").map((line, index) => (
        <span key={index}>
          {line}
          <br />
        </span>
      ))}
    </p>
  </div>
);

const ParagraphBlock = ({ content }) => <div className="referenceSheet__paragraph">🗣️ {content}</div>;

const renderSection = (section) => {
  switch (section.contentType) {
    case "kv_table":
      return (
        <div key={section.sectionId} className="referenceSheet__section">
          <h4 className="referenceSheet__sectionTitle">{section.heading}</h4>
          <KvTable rows={section.rows} />
        </div>
      );
    case "highlight":
      return <HighlightBlock key={section.sectionId} heading={section.heading} content={section.content} />;
    case "paragraph":
    default:
      return <ParagraphBlock key={section.sectionId} content={section.content} />;
  }
};

const ReferenceSheetCard = ({ pedagogicalContextCard }) => {
  if (!pedagogicalContextCard) return null;
  const { title, sections = [] } = pedagogicalContextCard;

  return (
    <div className="referenceSheet">
      <header className="referenceSheet__header">
        <h3>📌 {title}</h3>
      </header>
      <div className="referenceSheet__body">{sections.map(renderSection)}</div>
    </div>
  );
};

export default ReferenceSheetCard;
